<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Reorder Steps</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>

  <div cdkDropList class="drag_n_drop-list" (cdkDropListDropped)="drop($event)">
    <div class="drag_n_drop-box" *ngFor="let steps of ta_revised_reordered_workflow" cdkDrag>
      <div class="drag_n_drop-custom-placeholder" *cdkDragPlaceholder></div>
      <span><b>#{{steps.step_no}}</b> - {{steps.description  | ellipsis: ['150']}}</span>
    </div>
  </div>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="px-3 py-2">

  <button
    mat-raised-button
    [disabled]="inProgress"
    color="primary"
    type="button"
    (click)="onSaveOrder()"
    class="my-2 mx-1"
    id="save">
    <mat-icon>save</mat-icon>
    Save
  </button>

</mat-dialog-actions>
